export enum VariableType {
  variable = 'Variable',
  url = 'Url',
  body = 'Body',
  filePath = 'FilePath',
}
